module.exports = __webpack_public_path__ + "img/result6.b72342a4.png";